
import { BrowserRouter, Routes, Route,  } from 'react-router-dom';
import { HomePage, PrivacyPolicy } from './pages';
function App() {
  return (
    <div className="main">

      <BrowserRouter>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={(<PrivacyPolicy />)} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
